import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { useAuthenticationStore } from "@/store/authentication.store";

type UpperNavBadge = {
  text: string;
  colorClass: string;
};

export const useBadge = () => {
  const authStore = useAuthenticationStore();
  const { t } = useI18n();

  const selectedAccount = computed(() => authStore.selectedAccount);
  const selectedMsp = computed(() => authStore.selectedMsp);
  const selectedCustomer = computed(() => authStore.selectedCustomer);

  const getBadge = () => {
    if (!selectedAccount.value) {
      return null;
    }
    if (
      selectedAccount.value.type_name === "Customer" ||
      selectedCustomer.value?.uuid
    ) {
      return {
        text: t("customer"),
        colorClass: "tw-bg-nav-badge-customer",
      };
    }
    if (selectedAccount.value.type_name === "MSP" || selectedMsp.value?.uuid) {
      return {
        text: t("msp"),
        colorClass: "tw-bg-nav-badge-msp",
      };
    }
    if (selectedAccount.value.type_name === "System") {
      return {
        text: t("system"),
        colorClass: "tw-bg-nav-badge-system",
      };
    }
    if (selectedAccount.value.type_name === "Distributor") {
      return {
        text: t("distributor"),
        colorClass: "tw-bg-nav-badge-distributor",
      };
    }

    return null;
  };

  const badge: UpperNavBadge | null = getBadge();

  return { badge };
};
